
import { Component, Prop, Ref, Vue, Watch } from 'nuxt-property-decorator';
import findParentComponentByName from '@/util/findParentComponentByName';

@Component({})
export default class TableWrapper extends Vue {
  @Prop({ type: String, required: false, default: '' })
  bodytext: string;

  @Ref()
  tableContent: HTMLDivElement;

  @Ref()
  tableWrapper: HTMLDivElement;

  toggleComponent: Vue | null = null;
  isInToggleableElement: boolean = false;

  mounted(): void {
    this.testToggleableComponent();

    const elm = this.tableContent.$el ?? null;
    if (elm && elm.scrollWidth > elm.clientWidth) {
      elm.style.overflowX = 'scroll';
      if (elm.parentElement) {
        elm.parentElement.classList.add('overflow-right');
      }
    }
  }

  testToggleableComponent(): void {
    this.toggleComponent = this.parentIsToggleable;

    if (this.toggleComponent !== null) {
      const parentComponentisTogglableElement =
        this.toggleComponent?.$options?.propsData?.data?.element?.appearance
          ?.layout === 'toggleable' ||
        this.toggleComponent?.$options.propsData.expanded;
      this.isInToggleableElement = parentComponentisTogglableElement;
    }
  }

  handleScrollTable(e): void {
    if (e.target.scrollLeft === 0) {
      this.tableWrapper.classList.replace('overflow-left', 'overflow-right');
    } else {
      this.tableWrapper.classList.replace('overflow-right', 'overflow-left');
    }
  }

  @Watch('toggleState')
  onToggleStateChanged(state: boolean): void {
    if (state) {
      const elm = this.tableContent.$el ?? null;
      if (elm && elm.scrollWidth > elm.clientWidth) {
        elm.style.overflowX = 'scroll';
        elm.style.whiteSpace = 'noWrap';
        this.tableWrapper.classList.add('overflow-right');
        elm.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    } else {
      this.tableWrapper.classList.remove('overflow-right');
    }
  }

  get toggleState() {
    if (this.toggleComponent !== null) {
      return this.toggleComponent.isExpanded;
    }
  }

  get parentIsToggleable(): Vue | undefined {
    return findParentComponentByName('CeExtendedCmsGroup', this, 'Accordion');
  }
}
